import { render, staticRenderFns } from "./AdminNoPermission.vue?vue&type=template&id=562afc66&scoped=true"
import script from "./AdminNoPermission.vue?vue&type=script&lang=js"
export * from "./AdminNoPermission.vue?vue&type=script&lang=js"
import style0 from "./AdminNoPermission.vue?vue&type=style&index=0&id=562afc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562afc66",
  null
  
)

export default component.exports